const SITE_URL = "https://www.reignitespirit.com";

function normalizeUrl(value = "") {
  if (!value) return "";

  if (
    value.startsWith("http://") ||
    value.startsWith("https://")
  ) {
    return value;
  }

  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
}

export function createArticleSchema({
  title,
  description,
  slug,
  url,
  image,
  authorName,
  authorUrl,
  datePublished,
  dateModified,
  category,
  keywords = [],
}) {
  const articleUrl =
    url ||
    `${SITE_URL}/blog/${encodeURIComponent(slug || "")}`;

  const finalImage = normalizeUrl(
    image || "/og-blog.jpeg"
  );

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",

    "@id": `${articleUrl}#article`,

    headline: title,
    description,
    url: articleUrl,

    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": articleUrl,
    },

    image: {
      "@type": "ImageObject",
      url: finalImage,
      width: 1200,
      height: 630,
    },

    author: {
      "@type": "Person",
      name:
        authorName ||
        "ReigniteSpirit Editorial Team",
    },

    publisher: {
      "@id": `${SITE_URL}/#organization`,
    },

    datePublished,
    dateModified:
      dateModified || datePublished,

    inLanguage: "en",
  };

  if (authorUrl) {
    schema.author.url = normalizeUrl(authorUrl);
  }

  if (category) {
    schema.articleSection = category;
  }

  if (Array.isArray(keywords) && keywords.length > 0) {
    schema.keywords = keywords.join(", ");
  } else if (
    typeof keywords === "string" &&
    keywords.trim() !== ""
  ) {
    schema.keywords = keywords;
  }

  return schema;
}